var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.user)?_c('adam',{attrs:{"variant":"hub","company":_vm.user.company_id.toString()}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }